import AppConstants from "../../../config/app.constants";
import BranchFundingSourceHolidayBaseController from '../common/branch_funding_source_holiday.base.controller'

class BranchFundingSourceHolidayEditController extends BranchFundingSourceHolidayBaseController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, BranchFundingSourceHolidayService, BranchFundingSourceService, $q, DateUtil) {

        super(Auth, $state, User, BranchFundingSourceHolidayService, Modal, $translate, $stateParams)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.BranchFundingSourceHolidayService = BranchFundingSourceHolidayService;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.DateUtil = DateUtil;
        this.$q = $q;

        this.defaultModel = {
            branchId: User.getUser().branchId,
            name: null,
            holidayDate: null,
            repeat: false,
            selectedFundingSource: null,
            branchFundingSourceObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
        };

        this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: this.$translate.instant('common.yes'),
                off: this.$translate.instant('common.no'),
            },
            onColor: 'success',
            offColor: 'danger'
        };

        this.model = angular.copy(this.defaultModel)
    }

    $onInit() {
        this.$q.all([
            this.Service.get(this.$stateParams.id),
            this.getAllFundingSource('', 0)
        ])
            .then((data) => {
                this.fundingSourceHolidayObj = data[0];
                this.defaultModel = this.fundingSourceHolidayObj;
                this.rawId = this.fundingSourceHolidayObj.id;
                this.model.name = this.fundingSourceHolidayObj.name;
                this.model.holidayDate = this.DateUtil.convertToDate(this.fundingSourceHolidayObj.holidayDate);
                this.model.repeat = this.fundingSourceHolidayObj.repeat;

                if (this.fundingSourceHolidayObj.branchFundingSourceId) {
                    this.fundingSourceHolidayObj.branchFundingSource.Key = this.fundingSourceHolidayObj.branchFundingSource.id + ' | ' + this.fundingSourceHolidayObj.branchFundingSource.sourceName;
                    this.fundingSourceHolidayObj.branchFundingSource.Value = this.fundingSourceHolidayObj.branchFundingSource.id;
                }
                this.model.selectedFundingSource = this.fundingSourceHolidayObj.branchFundingSource;
            })
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.model.selectedFundingSource = this.fundingSourceHolidayObj.branchFundingSource;
    }

    update() {
        this.model.isUpdating = true;
        delete this.model.errorMessage;

        this.Service.update(this.$stateParams.id, {
            name: this.model.name,
            holidayDate: moment(this.model.holidayDate).format('YYYY-MM-DD'),
            repeat: this.model.repeat,
            branchFundingSourceId: this.model.selectedFundingSource.Value,
            branchId: this.model.branchId
        })
            .then(() => {
                window.history.go(-1);
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.model.errorMessage = e.message;
                })
            })
            .finally(() => {
                this.model.isUpdating = false;
            })
    }

    generateSearchObj(searchKey) {
        searchKey = searchKey || '';
        const obj = {
            queryJSON: {
                rules: [
                    {
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: "id",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "sourceName",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                }
                            ],
                            operator: "OR"
                        }
                    }
                ],
                operator: "AND"
            }
        }
        return obj.queryJSON.rules.length ? obj : null;
    }

    getAllFundingSource(searchKey, offset) {
        this.model.branchFundingSourceObj.loading = true;
        this.BranchFundingSourceService.all(this.generateSearchObj(searchKey), offset, AppConstants.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.branchFundingSourceObj.totalRecords = data.total;
                    this.model.branchFundingSourceObj.results = this.fundingSourceMap(data.results);
                }
                else {
                    const fundingSource = this.fundingSourceMap(data.results);
                    this.model.branchFundingSourceObj.results = this.model.branchFundingSourceObj.results.concat(fundingSource);
                }
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.branchFundingSourceObj.loading = false;
            })
    }

    fundingSourceMap(fundingSource) {
        return fundingSource.map((data) => {
            return {
                Key: data.id + ' | ' + data.sourceName,
                Value: data.id
            }
        });
    }
}
export default BranchFundingSourceHolidayEditController;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/edit/branch_funding_source_holiday.edit.controller.js